import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import useRequests from '../../Utils/useRequests';

const ProtectedRoute = ({ component: Component, personalDetailsRequired, ...rest }) => {
  const { getRequest } = useRequests();
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const checkPersonalDetails = async () => {
      if (personalDetailsRequired) {
        try {
          const res = await getRequest("get-user-info"); // your API endpoint
          if (res && res.code === 200) {
            let originalText = res.data;
            if(originalText.tax_residency && originalText.tax_id){
                setAllowed(true); 
            }
          } else {
            setAllowed(false); // not filled
          }
        } catch (err) {
          setAllowed(false);
        }
      } else {
        setAllowed(true);
      }
      setLoading(false);
    };

    checkPersonalDetails();
  }, [personalDetailsRequired, getRequest]);

  if (loading) return <div>Loading...</div>; // optional: spinner

  if (!allowed && personalDetailsRequired) {
    return <Redirect to="/profile" replace />;
  }

  return <Component {...rest} />;
};

export default ProtectedRoute;
